import {
  breakpointKeys,
  cascadeBreakpointKeys,
} from 'src/js/modules/element-settings/constants/breakpoints';
import { targetAttributes } from 'src/js/modules/element-settings/constants/target-attributes';
import { borderTargets, shadowTargets } from '../constants/targets';

const SPACING_OFF_VALUE = '0';
const SHADOW_OFF_VALUE = 'none';

const getResolvedValue = (state, elementId, target, breakpointKey) => {
  const values = state[elementId]?.[target];

  if (!values) {
    return undefined;
  }

  const cascadeKey = (
    cascadeBreakpointKeys[breakpointKey] || cascadeBreakpointKeys[breakpointKeys.DEFAULT]
  ).find((key) => values[key] !== undefined);

  return values[cascadeKey];
};

const isBorderEnabled = (state, elementId, breakpointKey) =>
  borderTargets.some(
    (target) => parseFloat(getResolvedValue(state, elementId, target, breakpointKey)) > 0
  );

const isShadowEnabled = (state, elementId, breakpointKey) =>
  shadowTargets.some((target) => {
    const value = getResolvedValue(state, elementId, target, breakpointKey);

    return Boolean(value) && String(value) !== SHADOW_OFF_VALUE;
  });

const isSurfaceEnabled = (state, elementId, breakpointKey) =>
  Boolean(getResolvedValue(state, elementId, targetAttributes.SURFACE, breakpointKey));

export const hasAutoPaddingTrigger = (state, elementIds, breakpointKey) =>
  elementIds.some(
    (elementId) =>
      isBorderEnabled(state, elementId, breakpointKey) ||
      isShadowEnabled(state, elementId, breakpointKey) ||
      isSurfaceEnabled(state, elementId, breakpointKey)
  );

export const hasResolvedPadding = (state, elementIds, paddingTarget, breakpointKey) =>
  elementIds.some((elementId) => {
    const value = getResolvedValue(state, elementId, paddingTarget, breakpointKey);

    return value !== undefined;
  });

export const hasEnabledResolvedPadding = (state, elementIds, paddingTarget, breakpointKey) =>
  elementIds.some((elementId) => {
    const value = getResolvedValue(state, elementId, paddingTarget, breakpointKey);

    return value !== undefined && value !== SPACING_OFF_VALUE;
  });

export const hasPaddingAtBreakpoint = (state, elementIds, paddingTarget, breakpointKey) =>
  elementIds.some((elementId) => state[elementId]?.[paddingTarget]?.[breakpointKey] !== undefined);
